import React from 'react'

export const AuthContext = React.createContext({
  isAuthenticated: false,
  login(login: string, password: string) {},
  logout() {},
})
